import { useTranslation } from "react-i18next";
import Table from "../../../components/Common/dataTable/index";
import ActionsDropdown, { Action } from "components/Common/ActionsDropdown";
import { Modal } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";


interface SuppliersTableProps {
  dataSource: any[];
  onEdit: (record: any) => void;
  onDelete: (record: any) => void;
  loading: boolean;
}
const { confirm } = Modal;
const SuppliersTable = ({
  dataSource,
  onEdit,
  onDelete,
  loading,
}: SuppliersTableProps) => {
  const { t } = useTranslation();
  const columns = [
    {
      title: t("name"),
      dataIndex: "name",
    },
    {
      title: t("email"),
      dataIndex: "email",
    },
    {
      title: t("phone"),
      dataIndex: "phone",
    },
    {
      title: t("expense_categories"),
      dataIndex: "expenseCategory",
      render: (expenseCategory: any) => expenseCategory?.name,
    },
    {
      title: t("actions"),
      dataIndex: "actions",
      render: (_: any, record: any) => {
        const actions: Action[] = [
          {
            label: t("edit"),
            icon: "ti ti-edit",
            actionType: "link",
            onClick: () => onEdit(record),
          },
          {
            label: t("delete"),
            icon: "ti ti-trash",
            actionType: "link",
            onClick: () => showDeleteConfirm(record.id),
          },
        ];
        return <ActionsDropdown actions={actions} />;
      },
    },
  ];

  const showDeleteConfirm = (id: string) => {
    confirm({
      title: t("are_you_sure_you_want_to_delete_this_supplier?"),
      icon: <ExclamationCircleOutlined />,
      content: t("this_action_cannot_be_undone"),
      okText: t("delete"),
      okType: "danger",
      cancelText: t("cancel"),
      okButtonProps: { disabled: loading },
      onOk: () => onDelete(id),
    });
  };

  return (
    <div className="mt-4">
      <div className="table-responsive">
        <Table columns={columns} dataSource={dataSource} pagination={true} />
      </div>
    </div>
  );
};

export default SuppliersTable;
